import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Row,
  Select,
  message,
} from "antd";
import { CameraOutlined, FileOutlined, PlusOutlined } from "@ant-design/icons";
import AuthService from "../../Services/AuthService";
import moment from "moment";
import PatientService from "../../Services/PatientService";
import dayjs from "dayjs";
import CommonService from "../../Services/CommonService";
import profile from "../../assets/images/profile.png";
import { validatePincode, validatePhoneNumber } from "../../utils/validation";
const { TextArea } = Input;
const validateEmail = (email) => /^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/.test(email);

const gender = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" },
];
const salutation = [
  { name: "Mr.", value: "Mr." },
  { name: "Mrs.", value: "Mrs." },
  { name: "Dr.", value: "Dr." },
  { name: "Ms.", value: "Ms." },
];
const bloodGroup = [
  { name: "A+", value: "A+" },
  { name: "A-", value: "A-" },
  { name: "B+", value: "B+" },
  { name: "B-", value: "B-" },
  { name: "AB+", value: "AB+" },
  { name: "AB-", value: "AB-" },
  { name: "O+", value: "O+" },
  { name: "O-", value: "O-" },
];
const marital = [
  { label: "Married", value: "M" },
  { label: "Unmarried", value: "U" },
  { label: "Seperated", value: "S" },
  { label: "Divorced", value: "D" },
  { label: "Widowed", value: "W" },
];

const AddFamilyMember = (props) => {
  const [photoValue, setPhotoValue] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [profileType, setProfileType] = useState(null);
  const fileInputRef = useRef(null);
  const [form] = Form.useForm();
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [genderValue, setGenderValue] = useState();
  const [bloodValue, setBloodValue] = useState();
  const [maritalStatus, setMaritalStatus] = useState();
  const [salutationValue, setSalutationValue] = useState();
  const [relationValue, setRelationValue] = useState();
  const [disable, setDisable] = useState(false);
  const [relationList, setRelationList] = useState([]);
  const [countries, setCountries] = useState([]);
  const [fields, setFields] = useState({
    firstname: "",
    lastname: "",
    city: "",
  });
  const [primaryPatData, setPrimaryPatData] = useState(null);
  const patJson = sessionStorage.getItem("patientData");
  const patObject = patJson ? JSON.parse(patJson) : null;
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const canvasRef = useRef(null);

  useEffect(() => {
    setProfileImage(process.env.REACT_APP_IMAGE_URL + props.data?.photoName);
    if (props.data && (props.data.dob || props.data.patientId)) {
      if (props.data.dob) {
        const formattedDob = dayjs(props.data.dob, "DD/MM/YYYY");
        if (formattedDob.isValid()) {
          const updatedPatientData = [props.data];
          updatedPatientData[0].dob = formattedDob;
          form.setFieldsValue(updatedPatientData[0]);
        }
      } else {
        form.setFieldsValue(props.data);
      }
    } else {
      console.error("No patient data or invalid patient ID");
    }
  }, [props.data]);

  useEffect(() => {
    getRelationsList();
    getCountriesList();
    fetchPrimaryPatData();
  }, []);

  useEffect(() => {
    if (fields.firstname) {
      const formattedFirstname =
        fields.firstname.charAt(0).toUpperCase() +
        fields.firstname.slice(1).toLowerCase();
      form.setFieldsValue({ firstName: formattedFirstname });
    }
    if (fields.lastname) {
      const formattedLastname =
        fields.lastname.charAt(0).toUpperCase() +
        fields.lastname.slice(1).toLowerCase();
      form.setFieldsValue({ lastName: formattedLastname });
    }
    if (fields.city) {
      const formattedcity =
        fields.city.charAt(0).toUpperCase() +
        fields.city.slice(1).toLowerCase();
      form.setFieldsValue({ city: formattedcity });
    }
  }, [fields]);

  const fetchPrimaryPatData = async () => {
    const payload = {
      patientId: patObject.patientId,
      status: 1,
    };
    try {
      const response = await PatientService.getPatient(payload);
      setPrimaryPatData(response.data[0]);
    } catch (e) {
      console.error(e);
    }
  };

  const getCountriesList = async () => {
    let payload = {
      status: 1,
    };
    const response = await CommonService.CountriesList(payload);
    setCountries(response.data);
  };

  const getRelationsList = async () => {
    const payload = { status: 1 };
    try {
      const response = await CommonService.RelationList(payload);
      setRelationList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes(),
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const StateList = (country_Id) => {
    let payload = { status: 1 };
    if (country_Id) {
      payload.country_Id = country_Id;
    }
    AuthService.stateMaster(payload).then((result) => {
      if (result.data.message === "Record Not Found") {
        setStateData([]);
      } else {
        setStateData(result.data || []);
      }
    });
  };

  // Fetch cities based on selected state
  const fetchCities = (state_Id) => {
    let payload = { status: 1 };
    if (state_Id) payload.state_Id = state_Id;
    CommonService.CityList(payload)
      .then((res) => {
        if (res && res.data) {
          setCityData(res.data);
        } else {
          setCityData([]);
        }
      })
      .catch((e) => console.error(e));
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validImageTypes.includes(file.type)) {
        message.error("Only image files (JPG, PNG, JPEG) are allowed!");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        let imageArray = reader.result.split(",");
        setProfileImage(reader.result);
        setPhotoValue(imageArray[1]);
        setProfileType(file.type.split("/")[1]);
      };
      reader.readAsDataURL(file);
    }
  };

  const openCamera = async () => {
    setIsCameraOpen(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (props.videoRef.current) {
        props.videoRef.current.srcObject = stream;
      }
    } catch (error) {
      console.error("Error accessing camera:", error);
      message.error("Please allow camera access in your browser settings.");
    }
  };

  const stopCamera = () => {
    if (props.videoRef.current && props.videoRef.current.srcObject) {
      const stream = props.videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      props.videoRef.current.srcObject = null;
    }
    setIsCameraOpen(false);
  };

  const capturePhoto = () => {
    const canvas = canvasRef.current;
    const video = props.videoRef.current;
    const context = canvas.getContext("2d");
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageDataUrl = canvas.toDataURL("image/png");

    setProfileImage(imageDataUrl);
    setPhotoValue(imageDataUrl.split(",")[1]);
    setProfileType("png");

    stopCamera();
  };

  const uploadOptions = [
    {
      key: "1",
      label: (
        <Button
          className="text-white bg-[#189FAA]"
          type="text"
          icon={<FileOutlined />}
          onClick={handleClick}
        >
          Choose File
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          className="text-white bg-[#189FAA]"
          type="text"
          icon={<CameraOutlined />}
          onClick={openCamera}
        >
          Take Picture
        </Button>
      ),
    },
  ];

  const onGenderChange = (values) => {
    setGenderValue(values);
  };

  const handleSalutation = (values) => {
    setSalutationValue(values);
  };
  const handleBloodGroup = (values) => {
    setBloodValue(values);
  };
  const handleMerital = (values) => {
    setMaritalStatus(values);
  };
  const handleRelation = (values) => {
    setRelationValue(values);
  };

  const handleSave = () => {
    let values = form.getFieldValue();
    setDisable(true);
    const mandatoryFields = [
      "salutation",
      "firstName",
      "lastName",
      "dob",
      "gender",
      "bloodGroup",
      "maritalStatus",
      "mobile",
      "address1",
      "city",
      "state",
      "country",
      "pinCode",
      "relationCode",
    ];

    const emptyFields = mandatoryFields.filter((field) => !values[field]);

    if (emptyFields.length > 0) {
      message.error("Please fill in all mandatory fields");
      setDisable(false);
      return;
    }
    if (values.parentname && !values.relation) {
      message.error("Please select relation.");
      setDisable(false);
      return;
    }

    if (!validatePhoneNumber(values.mobile)) {
      message.error("Please enter valid mobile number.");
      setDisable(false);
      return;
    }

    if (values.email && !validateEmail(values.email)) {
      message.error("Please enter a valid email.");
      setDisable(false);
      return;
    }

    if (
      values.emergencyContact &&
      !validatePhoneNumber(values.emergencyContact)
    ) {
      message.error(
        "Please enter 10 digit mobile number in emergency contact.",
      );
      setDisable(false);
      return;
    }

    if (values.pinCode && !validatePincode(values.pinCode)) {
      message.error("Please enter a valid Postal Code.");
      setDisable(false);
      return;
    }

    const relationDesc = relationList?.find(
      (rel) => rel.relationCode === values.relationCode,
    )?.relationDescription;
    const selectedCountry = countries?.find(
      (country) => country.country_Id === values.country,
    );
    if (props.data) {
      let payload = {
        ...props.data,
        address1: values.address1,
        address2: values.address2,
        city: values.city,
        country: selectedCountry
          ? selectedCountry?.country_Name
          : props.data.country,
        state: values.state,
        dob: dayjs(values.dob, "MM/DD/YYYY").format("MM/DD/YYYY"),
        email: values.email,
        bloodGroup: values.bloodGroup,
        salutation: values.salutation,
        firstName: values.firstName,
        lastName: values.lastName,
        relationCode: values.relationCode,
        relationDescription: relationDesc,
        gender: values.gender,
        modifiedBy: patObject?.patientId,
        maritalStatus: values.maritalStatus,
        mobile: values.mobile,
        modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        photo: photoValue,
        photoName: null,
        photoType: profileType,
        pinCode: values.pinCode,
        status: 1,
        insurance: values.insurance,
        emergencyContact: values.emergencyContact,
      };
      PatientService.patientUpdate(payload)
        .then((result) => {
          message.success("Family member edited successfully", 4);
          setDisable(false);
          props.handlFamEdit();
          props.onClose();
        })
        .catch((error) => {
          setDisable(false);
          console.error(error);
        });
    } else {
      let payload = {
        address1: values.address1,
        address2: values.address2,
        city: values.city,
        country: selectedCountry.country_Name,
        state: values.state,
        createdBy: patObject?.patientId,
        createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        dob: dayjs(values.dob, "MM/DD/YYYY").format("MM/DD/YYYY"),
        email: values.email,
        bloodGroup: values.bloodGroup,
        salutation: values.salutation,
        firstName: values.firstName,
        lastName: values.lastName,
        parentPatientId: patObject.patientId,
        parentPatientName: patObject.firstName,
        relationCode: values.relationCode,
        relationDescription: relationDesc,
        patientId: null,
        gender: values.gender,
        modifiedBy: patObject?.patientId,
        maritalStatus: values.maritalStatus,
        mobile: values.mobile,
        loginIdAvailableYN: null,
        modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        photo: photoValue,
        photoName: null,
        photoType: profileType,
        pinCode: values.pinCode,
        status: 1,
        account_Id: patObject.account_Id,
        account_Name: "",
        clinic_Id: patObject.clinic_Id,
        clinic_Name: "",
        insurance: values.insurance,
        emergencyContact: values.emergencyContact,
        sourceChannel: "Website",
        userId: primaryPatData.createdBy,
        userName: primaryPatData.userName,
      };
      PatientService.AddFamilyMember(payload)
        .then((result) => {
          message.success("Family member created successfully", 4);
          props.handleReload();
          setDisable(false);
          props.onClose();
        })
        .catch((error) => {
          setDisable(false);
          console.error(error);
        });
    }
  };

  return (
    <div>
      <Form
        form={form}
        // onFinish={onFinish}
        layout="vertical"
        className="grid grid-cols-5 sm:grid-cols-1  gap-3 w-full"
        autoComplete="off"
      >
        <>
          <div className="grid place-items-center">
            <Dropdown menu={{ items: uploadOptions }} trigger={["click"]}>
              <div className="Upload h-24 w-24 border-1 p-4 rounded-full cursor-pointer relative">
                <input
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                  ref={fileInputRef}
                />
                <div
                  // onClick={handleClick}
                  className="absolute bottom-0 right-0 rounded-full text-center p-1 bg-slate-300 cursor-pointer"
                  style={{ width: "24px", height: "24px", zIndex: 1 }}
                >
                  <PlusOutlined style={{}} />
                </div>
                {
                  profileImage && (
                    <img
                      src={profileImage}
                      className="absolute top-0 left-0 w-full h-full object-cover rounded-full"
                      alt=" "
                    />
                  )
                  //  : (
                  //   <img
                  //     src={profile}
                  //     className="absolute top-0 left-0 w-full h-full object-cover rounded-full"
                  //     alt="profile"
                  //   />
                  // )
                }
              </div>
            </Dropdown>
            {/* <label htmlFor="" className="mt-2">
              Upload Profile
            </label> */}
          </div>
          {isCameraOpen && (
            <div className="camera-container">
              <video ref={props.videoRef} autoPlay className="w-full h-48" />
              <canvas
                ref={canvasRef}
                width="200"
                height="200"
                style={{ display: "none" }}
              />
              <div className="flex justify-between">
                <Button type="primary" onClick={capturePhoto} className="mt-2">
                  Capture
                </Button>
                <Button
                  type="default"
                  onClick={stopCamera}
                  className="mt-2 text-white bg-[#189FAA]"
                >
                  Close
                </Button>
              </div>
            </div>
          )}
        </>
        <>
          <Form.Item
            name="salutation"
            label={
              <span>
                Salutation <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
          >
            <Select
              className="h-10"
              placeholder="Select"
              style={{
                width: "100%",
              }}
              value={salutationValue}
              onChange={handleSalutation}
              options={salutation.map((ele) => ({
                value: ele.value,
                label: ele.name,
              }))}
            />
          </Form.Item>
        </>
        <>
          <Form.Item
            name="firstName"
            label={
              <span>
                First Name <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
          >
            <Input
              // placeholder="Enter"
              className="h-10"
              onChange={(e) => {
                const value = e.target.value;
                const formattedValue =
                  value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
                setFields((prevState) => ({
                  ...prevState,
                  firstname: formattedValue,
                }));
              }}
              onKeyDown={(event) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                ];
                if (
                  !/^[a-zA-Z]$/.test(event.key) &&
                  !allowedKeys.includes(event.key)
                ) {
                  event.preventDefault();
                }
              }}
            />
          </Form.Item>
        </>
        <>
          <Form.Item
            name="lastName"
            label={
              <span>
                Last Name <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
          >
            <Input
              // placeholder="Enter"
              className="h-10"
              onChange={(e) => {
                const value = e.target.value;
                const formattedValue =
                  value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
                setFields((prevState) => ({
                  ...prevState,
                  lastname: formattedValue,
                }));
              }}
              onKeyDown={(event) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                ];
                if (
                  !/^[a-zA-Z]$/.test(event.key) &&
                  !allowedKeys.includes(event.key)
                ) {
                  event.preventDefault();
                }
              }}
            />
          </Form.Item>
        </>

        <>
          <Form.Item
            name="relationCode"
            label={
              <span>
                Relation <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
          >
            <Select className="h-10">
              {relationList?.map((relation) => (
                <Select.Option value={relation.relationCode}>
                  {relation.relationDescription}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </>

        <>
          <Form.Item
            name="dob"
            label={
              <span>
                DOB <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
          >
            <DatePicker
              format="DD-MM-YYYY"
              className="w-full h-10"
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
            />
          </Form.Item>
        </>
        <>
          <Form.Item name="email" label={<span>E-mail</span>}>
            <Input placeholder="Enter" className="h-10" />
          </Form.Item>
        </>
        <>
          <Form.Item
            label={
              <span>
                Gender <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
            name="gender"
          >
            <Select
              className="h-10"
              placeholder="Select"
              style={{
                width: "100%",
              }}
              value={genderValue}
              onChange={onGenderChange}
              options={gender.map((ele) => ({
                value: ele.value,
                label: ele.label,
              }))}
            />
          </Form.Item>
        </>
        <>
          <Form.Item
            label={
              <span>
                Blood Group <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
            name="bloodGroup"
          >
            <Select
              className="h-10"
              placeholder="Select"
              style={{
                width: "100%",
              }}
              value={bloodValue}
              onChange={handleBloodGroup}
              options={bloodGroup.map((ele) => ({
                value: ele.value,
                label: ele.name,
              }))}
            />
          </Form.Item>
        </>
        <>
          <Form.Item
            label={
              <span>
                Marital Status <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
            name="maritalStatus"
          >
            <Select
              className="h-10"
              placeholder="Select"
              style={{
                width: "100%",
              }}
              value={maritalStatus}
              onChange={handleMerital}
              options={marital.map((ele) => ({
                value: ele.value,
                label: ele.label,
              }))}
            />
          </Form.Item>
        </>
        <>
          <Form.Item
            name="mobile"
            label={
              <span>
                Mobile <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
          >
            <Input
              placeholder="Enter"
              className="h-10"
              maxLength={10}
              onKeyDown={(event) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                ];
                if (
                  !/[0-9]/.test(event.key) &&
                  !allowedKeys.includes(event.key)
                ) {
                  event.preventDefault(); // Prevent non-numeric and non-control key input
                }
              }}
              disabled={props.data}
            />
          </Form.Item>
        </>

        <>
          <Form.Item name="insurance" label={<span>Insurance</span>}>
            <Input placeholder="Enter" className="h-10" />
          </Form.Item>
        </>

        <>
          <Form.Item
            name="emergencyContact"
            label={<span>Emergency Contact</span>}
          >
            <Input
              placeholder="Enter"
              className="h-10"
              maxLength={10}
              onKeyDown={(event) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                ];
                if (
                  !/[0-9]/.test(event.key) &&
                  !allowedKeys.includes(event.key)
                ) {
                  event.preventDefault(); // Prevent non-numeric and non-control key input
                }
              }}
            />
          </Form.Item>
        </>

        <>
          <Form.Item
            name="address1"
            label={
              <span>
                Address 1 <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
          >
            <TextArea
              style={{
                resize: "none",
              }}
              rows={2}
            />
          </Form.Item>
        </>
        <>
          <Form.Item name="address2" label={<span>Address 2</span>}>
            <TextArea
              style={{
                resize: "none",
              }}
              rows={2}
            />
          </Form.Item>
        </>

        <>
          <Form.Item
            name="country"
            label={
              <span>
                Country <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
          >
            <Select
              allowClear
              className="h-10"
              placeholder="Select Country"
              onChange={(value) => {
                form.setFieldsValue({ state: undefined });
                if (value) {
                  StateList(value);
                }
              }}
            >
              {countries?.map((country) => (
                <Select.Option
                  key={country.country_Id}
                  value={country.country_Id}
                >
                  {country.country_Name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </>
        <>
          <Form.Item
            name="state"
            label={
              <span>
                State <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
          >
            <Select
              showSearch
              className="h-10"
              options={stateData.map((ele) => ({
                value: ele.stateId,
                label: ele.stateName,
              }))}
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={(value) => {
                form.setFieldsValue({ city: undefined });
                if (value) {
                  fetchCities(value);
                } else {
                  setCityData([]);
                }
              }}
            />
          </Form.Item>
        </>
        <>
          <Form.Item
            name="city"
            label={
              <span>
                City <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
          >
            <Select
              showSearch
              className="h-10"
              placeholder="Select City"
              allowClear
              options={cityData.map((c) => ({
                value: c.cityId || c.cityName,
                label: c.cityName,
              }))}
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            />
          </Form.Item>
        </>

        <>
          <Form.Item
            name="pinCode"
            label={
              <span>
                Postal Code <span style={{ color: "#FF000F" }}>*</span>
              </span>
            }
          >
            <Input
              placeholder="Enter"
              className="h-10"
              maxLength={6}
              onKeyDown={(event) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                ];
                if (
                  !/[0-9]/.test(event.key) &&
                  !allowedKeys.includes(event.key)
                ) {
                  event.preventDefault(); // Prevent non-numeric and non-control key input
                }
              }}
            />
          </Form.Item>
        </>
      </Form>
      <div className="flex flex-row items-center justify-end gap-3 mt-10 mb-5">
        <button
          className="md:min-w-32 w-[6rem] md:w-1/5 md:p-3 p-1 bg-White rounded-lg border text-primaryColor border-primaryColor font-semibold custom-button-shadow"
          onClick={props.onClose}
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          disabled={disable}
          className="md:min-w-32 w-[6rem] md:w-1/5 md:p-3 p-1 bg-primaryColor text-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50"
        >
          {props.data ? "Update" : "Save"}
        </button>
      </div>
    </div>
  );
};

export default AddFamilyMember;
